import { render, staticRenderFns } from "./BasicEdit.vue?vue&type=template&id=9603162c&"
import script from "./BasicEdit.vue?vue&type=script&lang=ts&"
export * from "./BasicEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports